import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { ProgressBar } from '@cp/ds/src/components/progressBar';
import { Roundel } from '@cp/ds/src/components/roundel';
import { CareerId } from '@common/const/catalog/career';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { getCareerIcon } from '@cp/entities/career';

export interface StepHeaderProps {
  stepNumber: number;
  totalSteps: number;
  careerId: CareerId;
  blockTitle: string;
  stepAction: React.ReactNode;
}
export const StepHeader: React.FC<StepHeaderProps> = ({ stepNumber, totalSteps, stepAction, careerId, blockTitle }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const progress = stepNumber / totalSteps;
  const Icon = getCareerIcon(careerId);
  return (
    <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ display: { xs: 'block', [MOBILE_BREAKPOINT_THRESHOLD]: 'none' } }}>
          <Roundel size="small">
            <Icon />
          </Roundel>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
          <Typography variant={isMobile ? 'h3' : 'h1'}>{blockTitle}</Typography>
          <Typography component="div" variant={isMobile ? 'caption' : 'body'}>
            <Box component="span" sx={{ color: theme.palette.text.secondary }}>
              Шаг {stepNumber} из {totalSteps}.
            </Box>
            <Box component="span">{stepAction}</Box>
          </Typography>
        </Box>
      </Box>
      <ProgressBar value={progress} />
    </Box>
  );
};
